import React, { useEffect, useState, useCallback } from 'react';
import { Button, Card, Form, Input, InputNumber, message, Popconfirm, Select, Space, Spin, Table, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { getFormattedDouble } from '../../utils/format';
import { marketStoryRequests } from '../../requests';
import MarketStoryFormFields from '../marketStoryFormFields/MarketStoryFormFields';
import './MarketStory.scss';

const { Option } = Select;

const MarketStory = ({ month, year, total, setTotal }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editForm] = Form.useForm();

  const fetchData = async (newMonth, newYear) => {
    const response = await marketStoryRequests.getAllByMonthAndYear(newMonth, newYear);
    setData(response.data);
    setTotal(response.data.reduce((t,a) => (t + a.value), 0));
  };

  useEffect(() => {
    fetchData(month, year);
  }, [month, year]);

  const handleCreate = async () => {
    form
      .validateFields()
      .then(async (values) => {
      console.log(values);
        const params = {
          ...values,
          value: values.value.replace(',', '.'),
          month,
          year,
        };
        await marketStoryRequests.create(params);
        form.resetFields();
        fetchData(month, year);
      })
      .catch((errorInfo) => {
        console.log('Erro na validação:', errorInfo);
      });
  };

  const handleDelete = async (id) => {
    await marketStoryRequests.delete(id);
    fetchData(month, year);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    editForm.setFieldsValue({
      ...record,
      value: record.value.toString().replace('.', ','),
    });
    setIsModalVisible(true);
  };

  const handleEditSubmit = async () => {
    try {
      const values = await editForm.validateFields();
      const params = {
        ...values,
        value: values.value.replace(',', '.'),
        month,
        year,
      };
      // Supondo que sua API possua um endpoint PUT para atualizar
      await marketStoryRequests.update(params, editingRecord.id);
      setIsModalVisible(false);
      setEditingRecord(null);
      fetchData(month, year);
    } catch (error) {
      console.log('Erro ao validar/atualizar:', error);
    }
  };

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      sorter: (a, b) => a.value - b.value,
      render: (text) => `R$ ${getFormattedDouble(text)}`,
    },
    {
      title: 'Subcategoria',
      dataIndex: 'subcategory',
      key: 'subcategory',
      render: (text) => {
        switch (text) {
          case 'MARKETSTORY_MARKET':
            return 'MarketStory + Market'
          case 'MARKETSTORY':
            return 'MarketStory'
          default:
            return text;
        }
      },
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      sorter: (a, b) => a.value - b.value,
      render: (text) => `R$ ${getFormattedDouble(text)}`,
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (record) => (
        <Space>
          <EditOutlined onClick={() => handleEdit(record)} style={{ cursor: 'pointer' }} />
          <Popconfirm
            title="Tem certeza que deseja excluir este registro?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sim"
            cancelText="Não"
          >
            <DeleteOutlined style={{ cursor: 'pointer' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="MarketStory">
      <Spin tip="Carregando" spinning={loading}>
        <Card title="Cadastrar novo" style={{ margin: '20px 0' }}>
          <Form form={form} autoComplete="off" layout="vertical" className="form-container">
            <MarketStoryFormFields />
            <Form.Item style={{ display: 'flex', flexDirection: 'column-reverse' }}>
              <Button type="primary" onClick={handleCreate}>
                Adicionar
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Table columns={columns} dataSource={data} pagination={false} />

        <Modal
          title="Editar Envio"
          visible={isModalVisible}
          onOk={handleEditSubmit}
          onCancel={() => { setIsModalVisible(false); setEditingRecord(null); }}
          okText="Salvar"
          cancelText="Cancelar"
        >
          <Form form={editForm} layout="vertical" autoComplete="off">
            <MarketStoryFormFields />
          </Form>
        </Modal>
      </Spin>
    </div>
  );
};

export default MarketStory;


//import React, { useEffect, useState, useCallback } from 'react';
//import { Button, Form, Input, InputNumber, message, Popconfirm, Select, Space, Spin, Table } from 'antd';
//import { DeleteOutlined } from '@ant-design/icons';
//import { getFormattedDouble } from '../../utils/format';
//import { validateCurrency } from '../../utils/validation';
//import { marketStoryRequests } from '../../requests';
//import './MarketStory.scss';
//
//const { Option } = Select;
//
//const MarketStory = ({ month, year, total, setTotal }) => {
//  const [form] = Form.useForm();
//  const [data, setData] = useState([]);
//  const [loading, setLoading] = useState(false);
//
//  const fetchData = async (newMonth, newYear) => {
//    const response = await marketStoryRequests.getAllByMonthAndYear(newMonth, newYear);
//    setData(response.data);
//    setTotal(response.data.reduce((t,a) => (t + a.value), 0));
//  }
//
//  useEffect(() => {
//    fetchData(month, year);
//  }, [month, year]);
//
//  const handleSubmit = async () => {
//    form
//      .validateFields()
//      .then((values) => {
//        values.marketStory_value = values.marketStory_value.replace(',', '.');
////        console.log(values);
//      })
//      .catch((errorInfo) => {
//        console.log('Erro na validação:', errorInfo);
//      });
//  };
//
//  function handleDelete(id) {
//    console.log('id ', id);
////    setLoading(true);
////    del({ url: `/report?id=${id}` }).then((response) => {
////      setLoading(false);
////      if (!response.error) {
////
////        // Remove e refaz a busca
////        if ((paginationInfo.current - 1) && paginationInfo.currentTotal === 1) {
////          // Se não é a página 1 e só tem um elemento na lista
////          // Faz a busca com o índice da página anterior
////          fetchData(paginationInfo.current - 1);
////        } else {
////          fetchData(paginationInfo.current);
////        }
////
////        message.success('Relatório excluído com sucesso');
////      } else {
////        message.error('Ocorreu um erro ao excluir o relatório');
////      }
////    }).catch((err) => {
////      console.log('Erro ', err);
////      message.error('Ocorreu um erro, tente novamente mais tarde');
////      setLoading(false);
////    });
//  }
//
//  const columns = [
//    {
//      title: 'Id',
//      dataIndex: 'id',
//      key: 'id',
//    },
//    {
//      title: 'Nome',
//      dataIndex: 'name',
//      key: 'name',
//    },
//    {
//      title: 'Valor',
//      dataIndex: 'value',
//      key: 'value',
//      sorter: (a, b) => a.value - b.value,
//      render: (text) => `R$ ${getFormattedDouble(text)}`,
//    },
//    {
//      title: 'Ações',
//      key: 'id',
//      render: (obj) => (
//        <Popconfirm
//          title="Tem certeza que deseja excluir este registro?"
//          onConfirm={() => handleDelete(obj.id)}
//          okText="Sim"
//          cancelText="Não"
//        >
//          <div className="action-item" style={{ cursor: 'pointer' }}>
//            <DeleteOutlined />
//          </div>
//        </Popconfirm>
//      ),
//    },
//  ];
//
//  return (
//    <div>
//      <Spin tip="Carregando" spinning={loading}>
//        <Form
//          form={form}
//          autoComplete="off"
//          layout="vertical"
//          style={{ display: 'flex', gap: 5 }}
//        >
//          <Form.Item
//            name="marketStory_name"
//            label="Nome"
//            rules={[{ required: true, message: 'Campo obrigatório!' }]}
//          >
//            <Input />
//          </Form.Item>
//
//          <Form.Item
//            name="marketStory_value"
//            label="Valor"
//            rules={[
//              { required: true, message: 'Campo obrigatório!' },
//              { validator: validateCurrency },
//            ]}
//          >
//            <Input />
//          </Form.Item>
//
//          <Form.Item style={{ display: 'flex', flexDirection: 'column-reverse' }}>
//            <Button type="primary" onClick={handleSubmit}>Adicionar</Button>
//          </Form.Item>
//        </Form>
//
//
//        <Table columns={columns} dataSource={data} pagination={false} />
//      </Spin>
//    </div>
//  )
//};
//
//export default MarketStory;
